import Gnn from '../features/Gnn/components/Gnn';
import RnrOverview from '../features/RnR/RnROverview/components/RnROverview';
import Winners from '../features/RnR/RnRWinners/components/Winners';
import BroadCast from '../features/Announcement/components/Announcements';
import { AboutMePage, Announcements, Blocked, Delights, Gift, ProfilePage, RnR, Shabash } from '../pages';
import { Navigate } from 'react-router-dom';
import ShabashWinners from '../features/Shabash/components/ShabashWinners';
import ShabashOverview from '../features/Shabash/ShabashOverview/ShabashOverview';
import NewsDetail from '../features/Gnn/components/NewsDetail';
import Comments from '../features/Comment/components/Comments';
import RnRDrawer from '../features/RnR/RnRForm/components/RnRDrawer';
import ShabashDrawer from '../features/Shabash/components/ShabashDrawer';
import Resume from '../features/Resume/components/Resume';
import LeaveManagement from '../features/WebView/components/LeaveManagement';
import GatewayBox from '../features/WebView/components/GatewayBox';
import withAbilityCheck from '../utils/withAbilityCheck';
import GatewayBot from '../pages/GatewayBot';
import FeedbackPage from '../pages/FeedbackPage';
import DeviceIsMobile from './components/IsMobile';
import CustomNavigate from './components/CustomNavigate';
import NewsComments from '../features/Gnn/components/NewsComments';
import MyGift from '../features/Gift/components/Candidate/MyGift';
import SubmittedGift from '../features/Gift/components/DeliveryHead/SubmittedGift';
import InterviewInvites from '../features/Gift/components/Interview/InterviewInvites';
import ManageGiftHR from '../features/Gift/components/HR/ManageGiftHR';
import ChatTabs from '../features/Search/components/ChatTabs';
import Chats from '../features/Chats/components/Chats';
import { webview } from '../app/api/webview';
import MobileView from '../features/WebView/components/MobileView';
import Connect from '../features/WebView/components/Connect';
import ConferenceRoom from '../features/WebView/components/ConferenceRoom';
import MeetingPlatform from '../features/WebView/components/MeetingPlatform';
import Reimbursement from '../features/WebView/components/Reimbursement';
import WallOfAchievements from '../features/WebView/components/WallOfAchievements';
import CertificateList from '../features/WebView/components/CertificateList';
const CommentsWithAbilityCheck = withAbilityCheck(Comments, 'create', 'Comment');
const RnRWithAbilityCheck = withAbilityCheck(RnRDrawer, 'create', 'RnR');
const ShabashDrawerWithAbilityCheck = withAbilityCheck(ShabashDrawer, 'create', 'Shabash');
const ResumeDrawerWithAbilityCheck = withAbilityCheck(Resume, 'create', 'Resume');
const AllRoutes = [
  { path: '', element: <DeviceIsMobile to="announcement" /> },
  { path: 'gbot', element: <GatewayBot /> },

  {
    path: 'announcement',
    element: <Announcements />,
    children: [
      { path: '', element: <Navigate to={'gnn'} /> },
      { path: 'board', element: <BroadCast /> },
      { path: 'leave', element: <LeaveManagement /> },
      { path: 'delights', element: <Delights /> },
      { path: 'feedback', element: <FeedbackPage /> },
      {
        path: 'gatewaybox',
        element: <GatewayBox />,
        children: [
          //   { path: 'connect', element: <Connect/> },
          //   // { path: 'connect', element: <MobileView URL={webview.Connect} comingSoon={false} /> },
          //   { path: 'conference-room', element: <ConferenceRoom /> },
          //   // { path: 'conference-room', element: <MobileView URL={webview.ConferenceRoomBooking} comingSoon={true} /> },
          //   { path: 'meeting-platform', element: <MeetingPlatform /> },
          //   // { path: 'meeting-platform', element: <MobileView URL={webview.Meetingplatform} comingSoon={true} /> },
          { path: 'travel-desk', element: <MobileView URL={webview.Travel_desk} comingSoon={true} /> },
          //   // { path: 'travel-desk', element: <MobileView URL={webview.Travel_desk} comingSoon={true} /> },
          //   { path: 'reimbursement', element: <Reimbursement /> },
          //   // { path: 'reimbursement', element: <MobileView URL={webview.TD_Reimbursement} comingSoon={true} /> },
          //   { path: 'leave', element: <LeaveManagement /> },
        ],
      },
      { path: 'gbox/connect', element: <Connect /> },
      // { path: 'connect', element: <MobileView URL={webview.Connect} comingSoon={false} /> },
      { path: 'gbox/conference-room', element: <ConferenceRoom /> },
      // { path: 'conference-room', element: <MobileView URL={webview.ConferenceRoomBooking} comingSoon={true} /> },
      { path: 'gbox/meeting-platform', element: <MeetingPlatform /> },
      // { path: 'meeting-platform', element: <MobileView URL={webview.Meetingplatform} comingSoon={true} /> },
      // { path: 'travel-desk', element: <MobileView URL={webview.Travel_desk} comingSoon={true} /> },
      // { path: 'travel-desk', element: <MobileView URL={webview.Travel_desk} comingSoon={true} /> },
      { path: 'gbox/reimbursement', element: <Reimbursement /> },
      // { path: 'reimbursement', element: <MobileView URL={webview.TD_Reimbursement} comingSoon={true} /> },
      { path: 'gbox/leave', element: <LeaveManagement /> },
      { path: 'gbox/wall-of-achievements', element: <WallOfAchievements /> },
      { path: 'gbox/certificate-wall', element: <CertificateList /> },
      { path: 'gnn', element: <Gnn />, children: [{ path: ':id', element: <NewsComments /> }] },
      { path: 'chatsList', element: <ChatTabs /> },
      { path: 'gnnDetails/:id', element: <NewsComments /> },
    ],
  },

  {
    path: 'profile/:empCode',
    element: <ProfilePage />,
    children: [
      { path: 'comment', element: <CommentsWithAbilityCheck /> },
      { path: 'rnr', element: <RnRWithAbilityCheck /> },
      { path: 'shabash', element: <ShabashDrawerWithAbilityCheck /> },
      { path: 'resume', element: <ResumeDrawerWithAbilityCheck /> },
    ],
  },

  {
    path: 'chats/:empCode',
    element: <ProfilePage />,
    children: [
      { path: '', element: <Chats /> },
      { path: 'comment', element: <CommentsWithAbilityCheck /> },
      { path: 'rnr', element: <RnRWithAbilityCheck /> },
      { path: 'shabash', element: <ShabashDrawerWithAbilityCheck /> },
      { path: 'resume', element: <ResumeDrawerWithAbilityCheck /> },
    ],
  },

  { path: 'aboutme/:empCode', element: <AboutMePage /> },

  {
    path: 'rnr',
    element: <RnR />,
    children: [
      { path: '', element: <Navigate to={'winners'} /> },
      { path: 'overview', element: <RnrOverview /> },
      { path: 'winners', element: <Winners />, children: [{ path: 'rnrNomination', element: <Winners /> }] },
    ],
  },

  { path: 'delights', element: <Delights /> },

  {
    path: 'gift',
    element: <Gift />,
    children: [
      { path: '', element: <CustomNavigate to={'manage'} redirect={'mygift'} action={'manage'} module={'GiftForm'} /> },
      {
        path: 'mygift',
        element: <MyGift />,
      },
      {
        path: 'submitted',
        element: <SubmittedGift />,
      },
      {
        path: 'invites',
        element: <InterviewInvites />,
      },
      {
        path: 'manage',
        element: <ManageGiftHR />,
      },
    ],
  },

  {
    path: 'shabash',
    element: <Shabash />,
    children: [
      { path: '', element: <Navigate to={'winners'} /> },
      { path: 'winners', element: <ShabashWinners />, children: [{ path: 'shabashNomination', element: <ShabashWinners /> }] },
      { path: 'overview', element: <ShabashOverview /> },
    ],
  },

  { path: 'feedback', element: <FeedbackPage /> },
];

export default AllRoutes;
